// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2-4Mj","row":"ProcedureTreatmentSummary_row__1MbiX"};